import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import EggsProduct from 'models/EggsProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { eggGradeOptions, packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const EggsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, Grade, ContainerSize } = current
      setPackaging({
        category,
        subCategory,
        Grade: {
          value: Grade || '',
          label: Grade.length > 0 ? Grade : 'Grade',
        },
        ContainerSize,
      })
    } else if (!updating) {
      setCurrent(EggsProduct)
      setCurrent(EggsProduct)
    }
    // eslint-disable-next-line
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Grade {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={eggGradeOptions}
          name="Grade"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Grade'}
          onChange={([selected]) => {
            setSelect(selected, 'Grade')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Grade"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={packaging.ContainerSize} disabled />
        </FormGroup>
        <br />
      </Col>
    </Row>
  )
}

export default EggsPackage

export const getEggsPackage = newProduct => {
  const newEggsPackage = {
    UPC: newProduct.UPC,
    Grade: newProduct.Grade,
    ContainerSize: newProduct.ContainerSize,
  }
  return newEggsPackage
}

export const updateEggsPackage = newProduct => {
  const newEggsPackage = {
    UPC: newProduct.UPC,
    ContainerSize: newProduct.ContainerSize,
    Grade: newProduct.Grade,
  }
  return newEggsPackage
}
